module.exports = __webpack_public_path__ + "img/4.3e59c1bf.png";